import React from 'react';

export default function EmoteIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      {/* Theater masks - emotes/performance */}
      <path
        d="M9 2C5.13 2 2 5.13 2 9c0 3.17 2.11 5.84 5 6.71V22l3-3 3 3v-6.29c2.89-.87 5-3.54 5-6.71 0-3.87-3.13-7-7-7z"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0"
      />
      {/* Happy face */}
      <circle cx="9" cy="10" r="7.5" fill={color} opacity="0.15" />
      <circle cx="9" cy="10" r="7.5" stroke={color} strokeWidth="1.5" fill="none" />
      <circle cx="7" cy="8.5" r="1" fill={color} />
      <circle cx="11" cy="8.5" r="1" fill={color} />
      <path d="M6 11.5c0 0 1.2 2 3 2s3-2 3-2" stroke={color} strokeWidth="1.3" strokeLinecap="round" fill="none" />
      {/* Sparkles around - emote effect */}
      <path d="M18 3l1 2.5L21.5 6.5 19 7.5 18 10l-1-2.5L14.5 6.5 17 5.5z" fill={color} opacity="0.7" />
      <path d="M20 13l.6 1.5 1.5.6-1.5.6-.6 1.5-.6-1.5-1.5-.6 1.5-.6z" fill={color} opacity="0.5" />
    </svg>
  );
}
